var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetSavingsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 659,
    height: 385,
    viewBox: "0 0 659 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M295.5 362.967C389.185 362.967 465.133 287.019 465.133 193.334C465.133 99.6476 389.185 23.7002 295.5 23.7002C201.814 23.7002 125.866 99.6476 125.866 193.334C125.866 287.019 201.814 362.967 295.5 362.967Z",
    stroke: "#7FB89A",
    strokeWidth: 0.969333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M295.5 338.733C375.802 338.733 440.9 273.636 440.9 193.333C440.9 113.031 375.802 47.9333 295.5 47.9333C215.197 47.9333 150.1 113.031 150.1 193.333C150.1 273.636 215.197 338.733 295.5 338.733Z",
    stroke: "#7FB89A",
    strokeWidth: 1.21167
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M295.5 314.5C362.418 314.5 416.666 260.252 416.666 193.333C416.666 126.415 362.418 72.1667 295.5 72.1667C228.581 72.1667 174.333 126.415 174.333 193.333C174.333 260.252 228.581 314.5 295.5 314.5Z",
    stroke: "#7FB89A",
    strokeWidth: 1.454
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M295.5 290.267C349.035 290.267 392.433 246.868 392.433 193.333C392.433 139.799 349.035 96.4001 295.5 96.4001C241.965 96.4001 198.566 139.799 198.566 193.333C198.566 246.868 241.965 290.267 295.5 290.267Z",
    stroke: "#7FB89A",
    strokeWidth: 2.42333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M295.5 290.267C349.035 290.267 392.433 246.868 392.433 193.333C392.433 139.799 349.035 96.4001 295.5 96.4001C241.965 96.4001 198.566 139.799 198.566 193.333C198.566 246.868 241.965 290.267 295.5 290.267Z",
    stroke: "#7FB89A",
    strokeWidth: 2.42333,
    strokeLinecap: "round",
    strokeDasharray: "395 608.26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M295.5 266.033C335.651 266.033 368.2 233.484 368.2 193.333C368.2 153.182 335.651 120.633 295.5 120.633C255.349 120.633 222.8 153.182 222.8 193.333C222.8 233.484 255.349 266.033 295.5 266.033Z",
    stroke: "#7FB89A",
    strokeWidth: 1.8175
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M295.5 241.8C322.267 241.8 343.967 220.101 343.967 193.333C343.967 166.566 322.267 144.867 295.5 144.867C268.732 144.867 247.033 166.566 247.033 193.333C247.033 220.101 268.732 241.8 295.5 241.8Z",
    stroke: "#7FB89A",
    strokeWidth: 1.8175
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M295.5 200.603C299.516 200.603 302.77 197.349 302.77 193.333C302.77 189.318 299.516 186.063 295.5 186.063C291.485 186.063 288.23 189.318 288.23 193.333C288.23 197.349 291.485 200.603 295.5 200.603Z",
    fill: "#7FB89A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M381.176 107.655L316.918 171.914",
    stroke: "#7FB89A",
    strokeWidth: 1.8175
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M316.918 171.914L322.059 159.919L328.913 166.773L316.918 171.914Z",
    fill: "#7FB89A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M378.606 105.085L383.747 110.226",
    stroke: "#7FB89A",
    strokeWidth: 1.8175
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M299.135 96.4002C299.135 94.3926 297.508 92.7652 295.5 92.7652C293.493 92.7652 291.865 94.3926 291.865 96.4002C291.865 98.4077 293.493 100.035 295.5 100.035C297.508 100.035 299.135 98.4077 299.135 96.4002Z",
    fill: "#7FB89A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M392.434 196.363C394.107 196.363 395.464 195.006 395.464 193.333C395.464 191.66 394.107 190.304 392.434 190.304C390.761 190.304 389.405 191.66 389.405 193.333C389.405 195.006 390.761 196.363 392.434 196.363Z",
    fill: "#7FB89A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M292.472 290.267C292.472 291.94 293.828 293.296 295.501 293.296C297.174 293.296 298.53 291.94 298.53 290.267C298.53 288.594 297.174 287.238 295.501 287.238C293.828 287.238 292.472 288.594 292.472 290.267Z",
    fill: "#7FB89A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M198.568 190.304C196.895 190.304 195.538 191.66 195.538 193.333C195.538 195.006 196.895 196.363 198.568 196.363C200.24 196.363 201.597 195.006 201.597 193.333C201.597 191.66 200.24 190.304 198.568 190.304Z",
    fill: "#7FB89A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.623 243.969C209.882 245.889 209.216 249.666 211.135 252.407C213.054 255.148 216.832 255.814 219.572 253.895C222.313 251.976 222.979 248.198 221.06 245.457C219.141 242.716 215.363 242.05 212.623 243.969Z",
    fill: "#7FB89A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M210.537 240.992C206.151 244.063 205.086 250.107 208.156 254.492C211.227 258.877 217.271 259.943 221.656 256.873C226.042 253.802 227.107 247.758 224.037 243.372C220.966 238.987 214.922 237.921 210.537 240.992Z",
    stroke: "#7FB89A",
    strokeWidth: 1.8175
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M295.5 193.333V72.1667",
    stroke: "#7FB89A",
    strokeWidth: 0.605833,
    strokeDasharray: "2.42 4.85"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M295.5 193.333H416.667",
    stroke: "#7FB89A",
    strokeWidth: 0.605833,
    strokeDasharray: "2.42 4.85"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M295.5 193.333V314.5",
    stroke: "#7FB89A",
    strokeWidth: 0.605833,
    strokeDasharray: "2.42 4.85"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M295.5 193.333L174.333 193.333",
    stroke: "#7FB89A",
    strokeWidth: 0.605833,
    strokeDasharray: "2.42 4.85"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M513.6 77.0134C516.276 77.0134 518.446 74.8435 518.446 72.1667C518.446 69.49 516.276 67.3201 513.6 67.3201C510.923 67.3201 508.753 69.49 508.753 72.1667C508.753 74.8435 510.923 77.0134 513.6 77.0134Z",
    fill: "#7FB89A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M513.6 77.0134V108.517",
    stroke: "#7FB89A",
    strokeWidth: 0.969333,
    strokeDasharray: "2.42 3.64"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M520.87 108.517H506.33C504.991 108.517 503.906 109.602 503.906 110.94V118.21C503.906 119.549 504.991 120.634 506.33 120.634H520.87C522.208 120.634 523.293 119.549 523.293 118.21V110.94C523.293 109.602 522.208 108.517 520.87 108.517Z",
    stroke: "#7FB89A",
    strokeWidth: 1.21167
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M77.4 100.641C79.7422 100.641 81.6408 98.7422 81.6408 96.4C81.6408 94.0579 79.7422 92.1592 77.4 92.1592C75.0579 92.1592 73.1592 94.0579 73.1592 96.4C73.1592 98.7422 75.0579 100.641 77.4 100.641Z",
    fill: "#7FB89A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M77.4004 100.641V120.633",
    stroke: "#7FB89A",
    strokeWidth: 0.969333,
    strokeDasharray: "2.42 3.64"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M82.2465 120.633H72.5532C71.2148 120.633 70.1299 121.718 70.1299 123.057V127.903C70.1299 129.242 71.2148 130.327 72.5532 130.327H82.2465C83.5849 130.327 84.6699 129.242 84.6699 127.903V123.057C84.6699 121.718 83.5849 120.633 82.2465 120.633Z",
    stroke: "#7FB89A",
    strokeWidth: 1.21167
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M537.834 369.025C554.563 369.025 568.125 355.463 568.125 338.733C568.125 322.004 554.563 308.442 537.834 308.442C521.104 308.442 507.542 322.004 507.542 338.733C507.542 355.463 521.104 369.025 537.834 369.025Z",
    stroke: "#E8F2ED",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSavingsIllustration);
export default __webpack_public_path__ + "static/media/target-savings-illustration.87888715db57b6db32eb3f9683be98a3.svg";
export { ForwardRef as ReactComponent };